<template>
	<div v-if="showModal" class="modal-view" @click="$emit('close')" @keydown.esc="$emit('close')">
		<div class="modal-box" @click.stop>
			<!-- Loading -->
			<div v-if="loading" class="modal-load">
				<div class="loader-wrapper">
					<div class="loader-container">
						<div class="loader top-20 left-30 right-0"></div>
					</div>
				</div>
			</div>
			<div class="modal-box-head">
				Изменение вызова
				<div style="cursor: pointer;" @click="closeModal">
					<img src="https://storage.yandexcloud.net/proektoria-education/static/icons/x-close.svg" alt="Закрыть">
				</div>
			</div>
			<div v-if="current" class="modal-box-header">
				<div class="modal-box-caption">Выбранный вызов: </div>
				<div class="modal-box-title">{{current.title}}</div>
			</div>
			<div class="modal-box-body">
				<div @click="changeChallenge(item.id)" class="challenge-item" :class="{'active': item.selected}" v-for="(item, i) in data" :key="i">
					<img :src="item.media['preview-cropped']" :alt="item.title">
				</div>
			</div>
			<div class="modal-box-footer">
				<div @click="submit" class="modal-accept-button" :class="{'active' : selectedID !== null}">
					<div class="modal-button-loader" :class="{'active' : sending}">
						<img src="https://storage.yandexcloud.net/proektoria-education/static/icons/loading-puff.svg" alt="Loading">
					</div>
					{{selectedID === null ? 'Выбирите вызов' : 'Поменять вызов'}}
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="css">
	.modal-view {
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.4);
		z-index: 9999999;
		overflow-y: scroll;
	}

	.modal-accept-button {
		position: relative;
		cursor: pointer;
		padding: 8px 33px;
		background-color: var(--black-40);
		color: #fff;
		font-family: 'Galiver Sans', sans-serif;
	}
	.modal-accept-button.active {
		background-color: var(--accent-2);
	}
	.modal-button-loader {
		position: absolute;
		display: none;
		justify-content: center;
		align-items: center;
		background-color: var(--accent-2);
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.modal-button-loader.active {
		display: flex;
	}
	.modal-button-loader img {
		width: 24px;
	}
	.modal-box {
		position: relative;
		min-height: 600px;
		max-width: 816px;
		width: 100%;
		margin: 0 auto;
		margin-top: 5%;
		background-color: #fff;
		display: flex;
		flex-direction: column;
	}
	.modal-box-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: normal;
		font-size: 12px;
		line-height: 120%;
		color: #262629;
		border-radius: 2px 2px 0px 0px;
		background: var(--main);
		padding: 12px 32px;
	}
	.modal-box-header {
		padding-top: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 32px;
	}
	.modal-box-footer {
		display: flex;
		justify-content: center;
		margin-bottom: 32px;
	}
	.modal-box-caption {
		font-weight: 500;
		font-size: 16px;
		line-height: 20px;
		color: #404044;
		margin-bottom: 8px;
	}
	.modal-box-title {
		font-family: 'Galiver Sans', sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 32px;
		line-height: 115%;
	}
	.modal-box-body {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
		padding: 16px;
		margin-bottom: 32px;
	}
	.challenge-item {
		margin: 6px;
		position: relative;
		width: 142px;
		height: 142px;
		border: 3px solid #fff;
		padding: 4px;
		cursor: pointer;
	}
	.challenge-item img {
		width: 100%;
	}
	.challenge-item.active {
		border: 3px solid #D0D0D3;
	}
	.challenge-item.active:before {
		content: '';
		position: absolute;
		background-image: url("https://storage.yandexcloud.net/proektoria-education/static/images/selected-challenge.png");
		background-size: 100%;
		top: 4px;
		right: 4px;
		width: 40px;
		height: 40px;
	}
	.modal-load {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		background: #fff;
	}
	@media (max-width: 992px) {
		.modal-box-body {
			padding: 0;
		}
	}
</style>
<script>
	import axios from 'axios';

	export default {
		props: {
			token: {
				type: String,
				default: '',
				require: true,
			},
			showModal: {
				type: Boolean,
				default: false,
				require: true,
			}
		},
		data() {
			return {
				data: [],
				loading: true,
				isSelected: false,
				selectedID: null,
				sending: false,
			}
		},
		computed: {
			current() {
				return this.data.find(item => {
					return item.id === this.selectedID;
				})
			}
		},
		methods: {
			closeModal() {
				this.$emit('close');
			},
			changeChallenge(id) {
				this.data.map(obj => {
					if(obj.id === id) {
						obj.selected = true;
					} else  {
						obj.selected = false;
					}
				});
				this.selectedID = id;
			},
			submit() {
				this.sending = true;
				axios.post(`https://edu-lb.proektoria.online/api/v1/external/user/challenge/select/${this.selectedID}?token=${this.token}`, {}, {
					progress: false
				}).then(res => {
					// this.selectedID = null;
					this.sending = false;
					this.$emit('update', res.data.item);
				}).catch(err => {
					console.log(err);
				});
			}
		},
		async mounted() {
			this.loading = true;
			await axios.get(`https://edu-lb.proektoria.online/api/v1/external/tracks?token=${this.token}`,  {
				progress: false
			}).then((res) => {
				this.selectedID = res.data.items.find(item => {
					return item.selected;
				}).id;

				this.data = res.data.items;
				this.loading = false;

			}).catch((e) => {
				console.log(e)
			});
		}
	}
</script>
